<template>
    <div class="AnswerKeys">
        <div class="top_time_box">
            <div>
                <img :src="require('@/common/images/examImgs/icon_clock.png')" alt="">
                <!-- <span>00:23:00</span> -->
                <van-count-down v-if="examInfoData.isastrict === 1" :auto-start="false" :time="time" />
                <span v-if="examInfoData.isastrict === 0">00:00:00</span>
                <!-- <van-count-down v-if="examInfoData.isastrict === 1" :time="time" /> -->
            </div>
            <div>
                <!-- <span>{{answerKyesInfoData.usecount}}</span> -->
                <span>{{page}}</span>
                <span>/{{answerKyesInfoData.allcount}}</span>
            </div>
        </div>
        <div class="exam_warp_box">
            <div class="subject_box">
                <p class="p_text">{{page}}.【{{examInfoData.questioninfo[0].questiontypename}}，{{examInfoData.questioninfo[0].quesscore}}分】</p>
                <p class="p_text" v-html="examInfoData.questioninfo[0].subject"></p>
                <div v-if="examInfoData.questioninfo[0].questiontype === 1" class="answer_box answer_type1">
                    <van-checkbox-group v-model="result" ref="checkboxGroup">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in list" clickable :key="index">
                                <van-checkbox :disabled="true" :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem">
                                    <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                    <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                </van-checkbox>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 2 || examInfoData.questioninfo[0].questiontype === 3" class="answer_box answer_type2">
                    <van-checkbox-group v-model="result">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in list" clickable :key="index">
                                <van-checkbox :disabled="true" :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem" shape="square">
                                    <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                    <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                </van-checkbox>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 4" class="answer_box answer_type5">
                    <van-checkbox-group v-model="result" ref="checkboxGroup">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in list" clickable :key="index">
                                <van-checkbox :disabled="true" :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem">
                                    <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                </van-checkbox>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 5" class="answer_box answer_type3">
                    <van-cell-group>
                        <van-cell v-for="(item, index) in textInputData" clickable :key="index">
                            <van-field :disabled="true" v-model="item.inputtext" :label="'（'+(index+1)+'）'" placeholder="未填写" />
                        </van-cell>
                    </van-cell-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 6" class="answer_box answer_type4">
                    <van-field :disabled="true" v-model="message" rows="6" autosize  type="textarea" placeholder="未填写" />
                </div>
                <div class="answer_parse_box" v-if="examInfoData.questioninfo[0].questiontype !== 7">
                    <div v-if="examInfoData.questioninfo[0].questiontype === 1 || examInfoData.questioninfo[0].questiontype === 2 || examInfoData.questioninfo[0].questiontype === 3" class="answer_parse_type1">
                        <div>
                            <span>参考答案</span>
                            <p>{{examInfoData.questioninfo[0].finalanswer}}</p>
                        </div>
                        <div>
                            <span>您的答案</span>
                            <p>{{userAnswerText === '' ? '--' : userAnswerText}}</p>
                        </div>
                        <div>
                            <span>本题得分</span>
                            <p>{{examInfoData.questioninfo[0].userscore}}分</p>
                        </div>
                    </div>
                    <div v-if="examInfoData.questioninfo[0].questiontype === 4" class="answer_parse_type1">
                        <div>
                            <span>参考答案</span>
                            <p>{{referenceAnswerText}}</p>
                        </div>
                        <div>
                            <span>您的答案</span>
                            <p>{{userAnswerText}}</p>
                        </div>
                        <div>
                            <span>本题得分</span>
                            <p>{{examInfoData.questioninfo[0].userscore}}分</p>
                        </div>
                    </div>
                    <div v-if="examInfoData.questioninfo[0].questiontype === 5" class="answer_parse_type2">
                        <div>
                            <span>参考答案</span>
                            <p>{{completionReferenceAnswerText === '' ? '暂无答案' : completionReferenceAnswerText}}</p>
                        </div>
                        <div>
                            <span>本题得分</span>
                            <span>{{examInfoData.questioninfo[0].userscore}}分</span>
                        </div>
                    </div>
                    <div v-if="examInfoData.questioninfo[0].questiontype === 6" class="answer_parse_type2">
                        <div>
                            <span>参考答案</span>
                            <p>{{examInfoData.questioninfo[0].referenceanswer === '' ? '暂无答案' : examInfoData.questioninfo[0].referenceanswer}}</p>
                        </div>
                        <div>
                            <span>本题得分</span>
                            <span v-if="examInfoData.ischeckover === 0">--</span>
                            <span v-if="examInfoData.ischeckover === 1">{{examInfoData.questioninfo[0].userscore}}分</span>
                        </div>
                        <div class="checkmemoBox">
                            <span>老师评语</span>
                            <p class="checkmemo" v-html="examInfoData.questioninfo[0].checkmemo"></p>
                        </div>
                    </div>
                    <p class="answer_parse_text">答案解析</p>
                    <p class="answer_parse_content_text" v-html="examInfoData.questioninfo[0].quesanalysis === '' ? '暂无答案解析' : examInfoData.questioninfo[0].quesanalysis"></p>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 7" class="answer_box answer_type7">
                    <div class="item" v-for="(obj, i) in examInfoData.questioninfo[0].questioninfo" :key="i">
                        <p class="p_text">{{examInfoData.questioninfo[0].questionindex}}.{{obj.questionindex}}【{{obj.questiontypename}}，{{obj.quesscore}}分】</p>
                        <p class="p_text" v-html="obj.subject"></p>
                        <div v-if="obj.questiontype === 1" class="answer_box materials_answer_box answer_type1">
                            <van-checkbox-group v-model="obj.result" ref="checkboxGroup">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in obj.list" clickable :key="index">
                                        <van-checkbox :disabled="true" :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem">
                                            <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                            <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                        </van-checkbox>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                        <div v-if="obj.questiontype === 2 || obj.questiontype === 3" class="answer_box materials_answer_box answer_type2">
                            <van-checkbox-group v-model="obj.result">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in obj.list" clickable :key="index">
                                        <van-checkbox :disabled="true" :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem" shape="square">
                                            <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                            <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                        </van-checkbox>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                        <div v-if="obj.questiontype === 4" class="answer_box materials_answer_box answer_type5">
                            <van-checkbox-group v-model="obj.result" ref="checkboxGroup">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in obj.list" clickable :key="index">
                                        <van-checkbox :disabled="true" :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem">
                                            <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                        </van-checkbox>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                        <div v-if="obj.questiontype === 5" class="answer_box materials_answer_box answer_type3">
                            <van-cell-group>
                                <van-cell v-for="(item, index) in obj.textInputData" clickable :key="index">
                                    <van-field :disabled="true" v-model="item.inputtext" :label="'（'+(index+1)+'）'" placeholder="未填写" />
                                </van-cell>
                            </van-cell-group>
                        </div>
                        <div v-if="obj.questiontype === 6" class="answer_box materials_answer_box answer_type4">
                            <van-field :disabled="true" v-model="obj.message" rows="6" autosize  type="textarea" placeholder="未填写" />
                        </div>
                        <div class="answer_parse_box">
                            <div v-if="obj.questiontype === 1 || obj.questiontype === 2 || obj.questiontype === 3" class="answer_parse_type1">
                                <div>
                                    <span>参考答案</span>
                                    <p>{{obj.finalanswer}}</p>
                                </div>
                                <div>
                                    <span>您的答案</span>
                                    <p>{{obj.userAnswerText === '' ? '--' : obj.userAnswerText}}</p>
                                </div>
                                <div>
                                    <span>本题得分</span>
                                    <p>{{obj.userscore}}分</p>
                                </div>
                            </div>
                            <div v-if="obj.questiontype === 4" class="answer_parse_type1">
                                <div>
                                    <span>参考答案</span>
                                    <p>{{obj.referenceAnswerText}}</p>
                                </div>
                                <div>
                                    <span>您的答案</span>
                                    <p>{{obj.userAnswerText}}</p>
                                </div>
                                <div>
                                    <span>本题得分</span>
                                    <p>{{obj.userscore}}分</p>
                                </div>
                            </div>
                            <div v-if="obj.questiontype === 5" class="answer_parse_type2">
                                <div>
                                    <span>参考答案</span>
                                    <p>{{obj.completionReferenceAnswerText === '' ? '暂无答案' : obj.completionReferenceAnswerText}}</p>
                                </div>
                                <div>
                                    <span>本题得分</span>
                                    <span>{{obj.userscore}}分</span>
                                </div>
                            </div>
                            <div v-if="obj.questiontype === 6" class="answer_parse_type2">
                                <div>
                                    <span>参考答案</span>
                                    <p>{{obj.referenceanswer === '' ? '暂无答案' : obj.referenceanswer}}</p>
                                </div>
                                <div>
                                    <span>本题得分</span>
                                    <span v-if="examInfoData.ischeckover === 0">--</span>
                                    <span v-if="examInfoData.ischeckover === 1">{{obj.userscore}}分</span>
                                </div>
                                <div class="checkmemoBox">
                                    <span>老师评语</span>
                                    <p class="checkmemo" v-html="examInfoData.questioninfo[0].checkmemo"></p>
                                </div>
                            </div>
                            <p class="answer_parse_text">答案解析</p>
                            <p class="answer_parse_content_text" v-html="obj.quesanalysis === '' ? '暂无答案解析' : obj.quesanalysis"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_handle_box">
            <div @click="upQuestion" class="handle_div">
                <img style="margin-right: 0.08rem;" :src="require('@/common/images/examImgs/icon_up.png')" alt="">
                <span>上一题</span>
            </div>
            <div class="scantron_box" @click="answerSheetClick">
                <img :src="require('@/common/images/examImgs/icon_answer.png')" alt="">
                <span>答题卡</span>
            </div>
            <div @click="nextQuestion" class="handle_div">
                <span>下一题</span>
                <img style="margin-left: 0.1rem;" :src="require('@/common/images/examImgs/icon_down.png')" alt="">
            </div>
        </div>
        <div class="answer_sheet_pop_box">
            <van-popup v-model="showAnswerSheet" position="bottom" :style="{ height: '100vh' }">
                <div class="answer_sheet_content_box">
                    <div class="answer_title_box">
                        <img @click="showAnswerSheet = false" :src="require('@/common/images/examImgs/icon_close_blue.png')" alt="">
                        答题卡
                    </div>
                    <div class="answer_select_box">
                        <div class="answer_item_box" v-for="(item, index) in answerKyesInfoData.answerkeysinfo" :key="index">
                            <div @click="subjectClick(index+1)" :class="answerClass(item.issubmit, item.answerstatus)">
                                {{index+1}}
                            </div>
                        </div>
                    </div>
                    <div class="answer_bottom_box">
                        <div>
                            <span>正确</span>
                            <div></div>
                            <span>错误</span>
                            <div></div>
                            <span>未做</span>
                            <div></div>
                        </div>
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import {Toast} from 'vant'
import {getAnswerSheetInfo, getQuestionList} from 'api/examApi'
import {mapGetters, mapActions} from 'vuex'
// import $ from 'jquery'
export default {
    name: 'AnswerKeys',
    data() {
        return {
            // time: 1.5 * 60 * 60 * 1000,
            time: 0,
            page: 1,
            answerKyesInfoData: {
                allcount: 0,
                usecount: 0,
                answerkeysinfo: []
            },
            examInfoData: {
                pageinfo: {
                    pageCount: 1,
                    rowCount: 100
                },
                questioninfo: [{}]
            },
            textInputData: [],
            message: '',
            list: [],
            result: [],
            showAnswerSheet: false,
            referenceAnswerText: '',
            completionReferenceAnswerText: '',
            userAnswerText: ''
        }
    },
    mounted() {
        if (!this.refresh) {
            this.findAnswerSheetInfo()
            this.findQuestionList()
        }
    },
    activated () {
        if (this.refresh) {
            this.findAnswerSheetInfo()
            this.findQuestionList()
            this.setRefresh(false)
        }
    },
    methods: {
        // 点击答题卡
        answerSheetClick() {
            this.showAnswerSheet = true
            // this.findAnswerSheetInfo()
        },
        // 获取答题卡信息
        findAnswerSheetInfo() {
            this.setLoading(true)
            var params = {
                exampid: this.$route.query.exampid
            }
            getAnswerSheetInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    // this.showAnswerSheet = true
                    this.answerKyesInfoData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取试题信息
        findQuestionList() {
            this.setLoading(true)
            var params = {
                clienttype: 2,
                examid: this.$route.query.exampid,
                page: this.page
            }
            getQuestionList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.showAnswerSheet = false
                    this.userAnswerText = ''
                    this.referenceAnswerText = ''
                    this.completionReferenceAnswerText = ''
                    if (data.data.isastrict === 1) {
                        this.time = data.data.examendtime * 1000
                    }
                    if (data.data.questioninfo[0].questiontype === 1 || data.data.questioninfo[0].questiontype === 2 || data.data.questioninfo[0].questiontype === 3) {
                        this.list = data.data.questioninfo[0].optionslist
                        if (data.data.questioninfo[0].issubmit === 1) {
                            this.result = data.data.questioninfo[0].uselanswer.split(',')
                            this.result = this.result.sort()
                            for (let index = 0; index < this.result.length; index++) {
                                this.userAnswerText = this.userAnswerText + this.result[index]
                            }
                            
                        } else {
                            this.$nextTick(() => {
                                this.result = []
                            })
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 4) {
                        this.list = [
                            {
                                optionsvalue: 'T',
                                optionsinfo: '正确'
                            },
                            {
                                optionsvalue: 'F',
                                optionsinfo: '错误'
                            }
                        ]
                        if (data.data.questioninfo[0].issubmit === 1) {
                            this.result = data.data.questioninfo[0].uselanswer.split(',')
                        } else {
                            this.result = []
                        }

                        if (data.data.questioninfo[0].finalanswer === 'T') {
                            this.referenceAnswerText = '正确'
                        } else {
                            this.referenceAnswerText = '错误'
                        }

                        if (data.data.questioninfo[0].uselanswer === 'T') {
                            this.userAnswerText = '正确'
                        } else if(data.data.questioninfo[0].uselanswer === 'F') {
                            this.userAnswerText = '错误'
                        } else {
                            this.userAnswerText = '--'
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 5) {
                        this.textInputData = []
                        this.completionReferenceAnswerText = data.data.questioninfo[0].finalanswerblank.answerblank.join('”、“') // 填空参考答案转换相应格式字符串
                        this.completionReferenceAnswerText = `“${this.completionReferenceAnswerText}”` // 填空参考答案转换相应格式字符串
                        for (let i = 0; i < data.data.questioninfo[0].finalanswerblank.answerblank.length; i++) {
                            this.textInputData.push({inputtext: ''})
                            // this.completionReferenceAnswerText = this.completionReferenceAnswerText + ' 、 ' + this.examInfoData.questioninfo[0].finalanswerblank.answerblank[i]
                            // this.completionReferenceAnswerText = this.completionReferenceAnswerText + this.examInfoData.questioninfo[0].finalanswerblank.answerblank[i] + ' 、 '
                        }
                        if (data.data.questioninfo[0].issubmit === 1) {
                            var testInput = data.data.questioninfo[0].uselanswer.split('|')
                            for (let j = 0; j < testInput.length; j++) {
                                this.textInputData[j].inputtext = testInput[j]
                            }
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 6) {
                        if (data.data.questioninfo[0].issubmit === 1) {
                            this.message = data.data.questioninfo[0].uselanswer
                        } else {
                            this.message = ''
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 7) {
                        data.data.questioninfo[0].questioninfo.forEach(obj => {
                            if (obj.questiontype === 1 || obj.questiontype === 2 || obj.questiontype === 3) {
                                obj.list = obj.optionslist
                                if (obj.issubmit === 1) {
                                    obj.result = obj.uselanswer.split(',')
                                    obj.result = obj.result.sort()
                                    obj.userAnswerText = ''
                                    for (let index = 0; index < obj.result.length; index++) {
                                        obj.userAnswerText = obj.userAnswerText + obj.result[index]
                                    }
                                    
                                } else {
                                    this.$nextTick(() => {
                                        obj.result = []
                                    })
                                }
                            }
                            if (obj.questiontype === 4) {
                                obj.list = [
                                    {
                                        optionsvalue: 'T',
                                        optionsinfo: '正确'
                                    },
                                    {
                                        optionsvalue: 'F',
                                        optionsinfo: '错误'
                                    }
                                ]
                                if (obj.issubmit === 1) {
                                    obj.result = obj.uselanswer.split(',')
                                } else {
                                    obj.result = []
                                }

                                if (obj.finalanswer === 'T') {
                                    obj.referenceAnswerText = '正确'
                                } else {
                                    obj.referenceAnswerText = '错误'
                                }

                                if (obj.uselanswer === 'T') {
                                    obj.userAnswerText = '正确'
                                } else if(obj.uselanswer === 'F') {
                                    obj.userAnswerText = '错误'
                                } else {
                                    obj.userAnswerText = '--'
                                }
                            }
                            if (obj.questiontype === 5) {
                                obj.textInputData = []
                                obj.completionReferenceAnswerText = obj.finalanswerblank.answerblank.join('”、“') // 填空参考答案转换相应格式字符串
                                obj.completionReferenceAnswerText = `“${obj.completionReferenceAnswerText}”` // 填空参考答案转换相应格式字符串
                                for (let i = 0; i < obj.finalanswerblank.answerblank.length; i++) {
                                    obj.textInputData.push({inputtext: ''})
                                    // this.completionReferenceAnswerText = this.completionReferenceAnswerText + ' 、 ' + this.examInfoData.questioninfo[0].finalanswerblank.answerblank[i]
                                    // this.completionReferenceAnswerText = this.completionReferenceAnswerText + this.examInfoData.questioninfo[0].finalanswerblank.answerblank[i] + ' 、 '
                                }
                                if (obj.issubmit === 1) {
                                    var testInput = obj.uselanswer.split('|')
                                    for (let j = 0; j < testInput.length; j++) {
                                        obj.textInputData[j].inputtext = testInput[j]
                                    }
                                }
                            }
                            if (obj.questiontype === 6) {
                                if (obj.issubmit === 1) {
                                    obj.message = obj.uselanswer
                                } else {
                                    obj.message = ''
                                }
                            }
                        })
                    }
                    this.examInfoData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 上一题
        upQuestion() {
            if (this.page === 1) {
                Toast('当前已是第一题')
            } else {
                // this.submitExamAnswer()
                // this.findAnswerSheetInfo()
                this.page = this.page - 1
                this.findQuestionList()
            }
        },
        // 下一题
        nextQuestion() {
            if (this.page === this.examInfoData.pageinfo.rowCount) {
                Toast('当前已是最后一题')
            } else {
                // this.submitExamAnswer()
                // this.findAnswerSheetInfo()
                this.page = this.page + 1
                this.findQuestionList()
            }
        },
        // 答题卡快捷点击到题目
        subjectClick(val) {
            // Toast(val)
            this.page = val
            this.findQuestionList()
        },
        // 答题卡选项颜色
        answerClass(val1, val2) {
            if (val1 === 1) {
                if (val2 === 1) {
                    return 'correct'
                } else if (val2 === 0) {
                    return 'mistake'
                }
            }
        },
        ...mapActions([
            'setLoading',
            'setRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .AnswerKeys {
        font-family:PingFangSC-Regular,PingFang SC;
        background:rgba(245,247,250,1);
        min-height: 100vh;
        .top_time_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 1rem;
            background-color: #fff;
            padding: 0 0.32rem;
            &>div:nth-of-type(1){
                display: flex;
                align-items: center;
                &>img{
                    width: 0.38rem;
                    height: 0.38rem;
                    margin-right: 0.24rem;
                }
                &>span{
                    font-size: 0.32rem;
                    color: #409EFF;
                }
                .van-count-down {
                    font-size: 0.32rem;
                    color: #409EFF;
                }
            }
            &>div:nth-of-type(2){
                &>span{
                    font-size: 0.28rem;
                    color: #999;
                }
                &>span:nth-of-type(1){
                    font-size: 0.36rem;
                    color: #333;
                }
            }
        }
        .exam_warp_box {
            // background-color: pink;
            height: calc(100vh - 2.8rem);
            overflow: auto;
            padding: 0.3rem 0.32rem;
            padding-bottom: 1rem;
            .subject_box {
                .p_text {
                    font-size: 0.28rem;
                    line-height:0.48rem;
                    text-align: justify;
                    line-height: 1.5;
                    img {
                        max-width: 100%;
                    }
                }
                .answer_box {
                    margin-top: 0.3rem;
                    background-color: #fff;
                    border-radius:0.1rem;
                    overflow: hidden;
                    .van-cell:not(:last-child)::after {
                        width: 90%;
                    }
                    .van-checkbox__icon {
                        line-height: 1.18em;
                    }
                    .van-checkbox__label {
                        color: #323233!important;
                    }
                    .van-checkbox__icon--checked .van-icon {
                        color: #fff!important;
                        background-color: #1989fa!important;
                        border-color: #1989fa!important;
                    }
                    .optionsinfoItem {
                        line-height: 1.5;
                        img {
                            max-width: 100%;
                        }
                    }
                    // .van-checkbox__icon--disabled .van-icon {
                    //     background-color: #fff;
                    // }
                }
                .answer_type7 {
                    background: #F5F7FA;
                    .item {
                        // background: #fff;
                        &:not(:first-of-type) {
                            margin-top: 0.3rem;
                        }
                        .p_text {
                            background: #F5F7FA;
                        }
                        .materials_answer_box {
                            background: #fff;
                        }
                    }
                }
                .answer_type3 {
                    .van-cell {
                        padding: 0.2rem 0.32rem;
                        padding: 0;
                    }
                    .van-field {
                        padding: 0;
                        padding: 0.2rem 0.32rem;
                    }
                    .van-field__label {
                        width: 0.74rem;
                        white-space: nowrap;
                    }
                }
                .answer_parse_box{
                    margin-top: 0.3rem;
                    background-color: #fff;
                    padding: 0.2rem 0.24rem;
                    border-radius:0.04rem;
                    overflow: hidden;
                    .answer_parse_type1 {
                        // background-color: pink;
                        display: flex;
                        // justify-content: space-between;
                        border-bottom: 0.01rem solid #E5E5E5;
                        padding-bottom: 0.15rem;
                        &>div{
                            padding: 0 0.66rem;
                            &>span{
                                color: #999;
                                font-size: 0.24rem;
                                line-height:0.34rem;
                                margin-bottom: 0.12rem;
                            }
                            &>p{
                                color: #FF4747;
                                text-align: center;
                                line-height:0.4rem;
                                font-size: 0.28rem;
                            }
                        }
                        &>div:nth-of-type(1){
                            padding-left: 0.42rem;
                            &>p{
                                color: #0ABF53;
                            }
                        }
                        &>div:nth-of-type(2){
                            border-left: 0.01rem solid #E5E5E5;
                            border-right: 0.01rem solid #E5E5E5;
                        }
                        &>div:nth-last-of-type(1){
                            padding-right: 0.42rem;
                        }
                    }
                    .answer_parse_type2 {
                        &>div {
                            border-bottom: 0.01rem solid #E5E5E5;
                            &>p {
                                color: #333;
                                font-size: 0.28rem;
                                line-height:0.4rem;
                                text-align: justify;
                                margin-top: 0.12rem;
                            }
                            &>span {
                                color: #999;
                                font-size: 0.24rem;
                                line-height:0.34rem;
                            }
                            &>span:nth-of-type(2) {
                                color: #FF4747;
                                font-size: 0.28rem;
                                line-height:0.4rem;
                                margin-left: 0.2rem;
                            }
                        }
                        &>div:nth-of-type(1) {
                            padding-bottom: 0.2rem;
                        }
                        &>div:nth-of-type(2) {
                            height: 0.74rem;
                            display: flex;
                            align-items: center;
                        }
                        .checkmemoBox {
                            padding: 0.16rem 0;
                            .checkmemo {
                                color: #333;
                                font-size: 0.28rem;
                                line-height: 0.4rem;
                                text-align: justify;
                                margin-top: 0.12rem;
                                line-height: 1.5;
                                img {
                                    max-width: 100%;
                                }
                            }
                        }
                    }
                    .answer_parse_text {
                        color: #999;
                        font-size: 0.24rem;
                        line-height:0.34rem;
                        margin-top: 0.2rem;
                        margin-bottom: 0.1rem;
                    }
                    .answer_parse_content_text{
                        color: #333;
                        font-size: 0.28rem;
                        line-height:0.4rem;
                        text-align: justify;
                    }
                }
            }
        }
        .bottom_handle_box {
            position: fixed;
            bottom: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.32rem;
            box-sizing: border-box;
            background:#fff;
            width: 100%;
            height: 1rem;
            &>div{
                display: flex;
                align-items: center;
                justify-content: center;
                &>img {
                    width: 0.24rem;
                    height: 0.24rem;
                }
                &>span {
                    color:rgba(64,158,255,1);
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                }
            }
            // &>div:active{
            //     background-color: rgba(0,0,0,0.1);
            // }
            // .handle_div {}
            .scantron_box {
                flex-direction: column;
                &>img {
                    width: 0.38rem;
                    height: 0.38rem;
                }
                &>span {
                    font-size: 0.2rem;
                    line-height: 0.28rem;
                    margin-top: 0.05rem;
                }
            }
        }
        .answer_sheet_pop_box {
            .answer_sheet_content_box {
                width: 100%;
                height: 100%;
                background:rgba(245,247,250,1);
                display: flex;
                flex-direction: column;
                .answer_title_box {
                    // background-color: rgb(179, 231, 179);
                    height: 1rem;
                    line-height: 1rem;
                    text-align: center;
                    font-size: 0.32rem;
                    position: relative;
                    &>img{
                        position: absolute;
                        right: 0.34rem;
                        top: 0.37rem;
                        width: 0.24rem;
                        height: 0.24rem;
                    }
                }
                .answer_select_box {
                    background-color: #fff;
                    flex: 1;
                    padding: 0.32rem;
                    overflow: auto;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    .answer_item_box{
                        &>div {
                            box-sizing: border-box;
                            width:0.8rem;
                            height:0.8rem;
                            line-height:0.8rem;
                            text-align: center;
                            background:rgba(229,229,229,1);
                            border-radius:0.04rem;
                            border:0.01rem solid rgba(207,207,207,1);
                            margin-right: 0.4rem;
                            margin-top: 0.3rem;
                            font-size: 0.32rem;
                        }
                        .correct{
                            color: #fff;
                            background:rgba(10,191,83,1);
                            border:0.01rem solid rgba(10,191,83,1);
                        }
                        .mistake{
                            color: #fff;
                            background:rgba(245,108,108,1);
                            border:0.01rem solid rgba(245,108,108,1);
                        }
                    }
                    .answer_item_box:nth-of-type(1), .answer_item_box:nth-of-type(2), .answer_item_box:nth-of-type(3), .answer_item_box:nth-of-type(4), .answer_item_box:nth-of-type(5), .answer_item_box:nth-of-type(6){
                        &>div{
                            margin-top: 0;
                        }
                    }
                    .answer_item_box:nth-of-type(6n){
                        &>div{
                            margin-right: 0;
                        }
                    }
                }
                .answer_bottom_box {
                    // background-color: #ccc;
                    height: 0.9rem;
                    &>div:nth-of-type(1){
                        height: 0.9rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &>span{
                            line-height:0.3rem;
                            margin-right: 0.12rem;
                            font-size: 0.22rem;
                        }
                        &>div{
                            border-radius:0.02rem;
                            border:0.01rem solid rgba(10,191,83,1);
                            box-sizing: border-box;
                            width: 0.24rem;
                            height: 0.24rem;
                            background:#0ABF53;
                            margin-right: 0.4rem;
                        }
                        &>div:nth-of-type(2){
                            background:#F56C6C;
                            border-color: rgba(245,108,108,1);
                        }
                        &>div:nth-of-type(3){
                            background:rgba(229,229,229,1);
                            border-color: rgba(207,207,207,1);
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }
</style>